if (!customElements.get('kit-pdp')) {
  customElements.define(
    'kit-pdp',
    class KitPdp extends HTMLElement {
      connectedCallback() {
        this.variantInput = this.querySelector('[data-product-variant-id]');
        this.price = this.querySelector('[data-current-price]');
        this.comparePrice = this.querySelector('[data-compare-price]');
        this.discount = this.querySelector('[data-discount]');
        this.addButton = this.querySelector('.kit-pdp__add-button');
        this.addButtonLabel = this.querySelector('[data-add-button-label]');
        this.variants = this.readJson('[data-kit-variants]');
        this.giftsStep = this.querySelector('[data-gifts-step]');
        this.giftCount = this.querySelector('[data-gift-count]');
        this.giftShell = this.querySelector('.kit-pdp__gift-shell');
        this.giftTrack = this.querySelector('[data-gift-track]');
        this.selectedOption = this.querySelector('[data-selected-option]');
        this.syncGiftOverflow = this.syncGiftOverflow.bind(this);

        this.querySelectorAll('[data-kit-card] input').forEach((input) => {
          input.addEventListener('change', (event) => this.selectVariant(event.currentTarget));
        });

        this.giftTrackControls = this.bindScrollableTrack('[data-gift-track]', '[data-track-previous]', '[data-track-next]', '.kit-pdp__gift-card');
        this.bindScrollableTrack('[data-kit-track]', '[data-kit-track-previous]', '[data-kit-track-next]', '.kit-pdp__kit-card');
        this.bindGalleryControls();
        window.addEventListener('resize', this.syncGiftOverflow, { passive: true });
        const initialVariantId = this.variantInput?.value;
        const initialVariant = this.variants.find((item) => String(item.id) === String(initialVariantId));
        if (initialVariant) this.renderGifts(initialVariant);
      }

      readJson(selector) {
        const element = this.querySelector(selector);
        if (!element) return [];

        try {
          return JSON.parse(element.textContent);
        } catch (error) {
          return [];
        }
      }

      selectVariant(input) {
        const variant = this.variants.find((item) => String(item.id) === String(input.dataset.variantId));
        if (!variant) return;

        this.querySelectorAll('[data-kit-card]').forEach((card) => {
          card.classList.toggle('is-selected', card.contains(input));
        });

        if (this.variantInput) this.variantInput.value = variant.id;
        if (this.selectedOption) this.selectedOption.textContent = variant.optionValue || '';
        if (this.price) this.price.textContent = variant.price;

        if (this.comparePrice) {
          this.comparePrice.textContent = variant.compareAt || '';
          this.comparePrice.classList.toggle('is-hidden', !variant.compareAt);
        }

        if (this.discount) {
          this.discount.textContent = `${this.dataset.saveLabel || 'SAVE'} ${variant.discount}%`;
          this.discount.classList.toggle('is-hidden', !variant.discount);
        }

        if (this.addButton) this.addButton.disabled = !variant.available;
        if (this.addButtonLabel) {
          this.addButtonLabel.textContent = variant.available
            ? `${this.dataset.addLabel || 'ADD TO CART'} — ${variant.price}`
            : this.dataset.soldOutLabel || 'SOLD OUT';
        }

        this.renderGifts(variant);

        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', `${nextUrl.pathname}${nextUrl.search}`);
        this.refreshGallery(variant.id, variant.featuredMediaId);
      }

      renderGifts(variant) {
        if (!this.giftsStep || !this.giftTrack || !this.giftShell) return;

        const giftTitles = variant.giftTitles || [];
        const giftPrices = variant.giftPrices || [];
        const giftImages = variant.giftImages || [];
        const gifts = giftTitles
          .map((title, index) => ({
            image: giftImages[index] || null,
            title,
            price: giftPrices[index] || '',
          }))
          .filter((gift) => gift.image || gift.title || gift.price);
        this.giftsStep.hidden = gifts.length === 0;
        if (this.giftCount) this.giftCount.textContent = gifts.length;

        this.giftItemCount = gifts.length;
        this.syncGiftOverflow();
        this.giftTrack.style.setProperty('--kit-pdp-gift-columns', Math.min(Math.max(gifts.length, 1), 4));
        this.giftTrack.replaceChildren();

        gifts.forEach((gift) => {
          const card = document.createElement('article');
          card.className = 'kit-pdp__gift-card';

          const inner = document.createElement('div');
          inner.className = 'kit-pdp__gift-card-inner';

          const imageWrap = document.createElement('div');
          imageWrap.className = 'kit-pdp__gift-image-wrap';
          if (gift.image) {
            const image = document.createElement('img');
            image.className = 'kit-pdp__gift-image';
            image.src = gift.image;
            image.alt = gift.title || '';
            image.loading = 'lazy';
            imageWrap.append(image);
          }

          const title = document.createElement('h3');
          title.className = 'kit-pdp__gift-title';
          title.textContent = gift.title || '';

          const price = document.createElement('p');
          price.className = 'kit-pdp__gift-value';
          price.textContent = gift.price || '';

          inner.append(imageWrap, title, price);
          card.append(inner);
          this.giftTrack.append(card);
        });

        this.giftTrack.scrollLeft = 0;
        this.giftTrackControls?.();
      }

      syncGiftOverflow() {
        if (!this.giftShell) return;

        const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const overflowLimit = isMobile ? 3 : 4;
        this.giftShell.classList.toggle('has-overflow', (this.giftItemCount || 0) > overflowLimit);
        this.giftTrackControls?.();
      }

      refreshGallery(variantId, featuredMediaId) {
        const gallery = this.querySelector('[data-native-gallery]');
        if (!gallery) return;

        const requestUrl = new URL(window.location.href);
        requestUrl.searchParams.set('variant', variantId);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);

        fetch(requestUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newGallery = html.querySelector('[data-native-gallery]');
            const newModal = html.querySelector(`#ProductModal-${this.dataset.sectionId}`);
            if (newGallery) gallery.innerHTML = newGallery.innerHTML;

            const currentModal = this.querySelector(`#ProductModal-${this.dataset.sectionId}`);
            if (currentModal && newModal) currentModal.innerHTML = newModal.innerHTML;

            const mediaGallery = gallery.querySelector('media-gallery');
            if (mediaGallery?.setActiveMedia && featuredMediaId) {
              mediaGallery.setActiveMedia(`${this.dataset.sectionId}-${featuredMediaId}`, true);
            }

            this.bindGalleryControls();
          })
          .catch((error) => console.error(error));
      }

      bindScrollableTrack(trackSelector, previousSelector, nextSelector, cardSelector) {
        const track = this.querySelector(trackSelector);
        const previous = this.querySelector(previousSelector);
        const next = this.querySelector(nextSelector);
        if (!track || !previous || !next) return null;

        const setArrowState = (button, disabled) => {
          button.disabled = disabled;
          const icon = button.querySelector('.kit-pdp__arrow-icon path');
          if (!icon) return;

          icon.setAttribute('stroke', disabled ? '#8A8A8A' : '#111111');
        };

        const updateControls = () => {
          const maxScroll = track.scrollWidth - track.clientWidth;
          setArrowState(previous, track.scrollLeft <= 1);
          setArrowState(next, track.scrollLeft >= maxScroll - 1);
        };

        const scroll = (direction) => {
          const card = track.querySelector(cardSelector);
          if (!card) return;
          const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
        };

        previous.addEventListener('click', () => scroll(-1));
        next.addEventListener('click', () => scroll(1));
        track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls, { passive: true });
        updateControls();
        return updateControls;
      }

      bindGalleryControls() {
        const thumbnailSlider = this.querySelector('.kit-pdp__gallery .thumbnail-slider');
        const thumbnailList = thumbnailSlider?.querySelector('.thumbnail-list');
        if (!thumbnailSlider || !thumbnailList || thumbnailSlider.querySelector('[data-kit-gallery-controls]')) return;

        const controls = document.createElement('div');
        controls.className = 'kit-pdp__gallery-controls';
        controls.dataset.kitGalleryControls = '';

        const createButton = (direction, label) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `kit-pdp__gallery-control kit-pdp__gallery-control--${direction}`;
          button.setAttribute('aria-label', label);

          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('class', 'kit-pdp__arrow-icon');
          icon.setAttribute('viewBox', '0 0 20 20');
          icon.setAttribute('fill', 'none');
          icon.setAttribute('aria-hidden', 'true');

          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M7 4.5L12.5 10L7 15.5');
          icon.append(path);
          button.append(icon);

          return button;
        };

        const previous = createButton('previous', 'Previous images');
        const next = createButton('next', 'Next images');
        const scrollByPage = (direction) => {
          const card = thumbnailList.querySelector('.thumbnail-list__item');
          const gap = Number.parseFloat(getComputedStyle(thumbnailList).columnGap) || 0;
          thumbnailList.scrollBy({ left: direction * ((card?.offsetWidth || 0) + gap), behavior: 'smooth' });
        };
        const updateControls = () => {
          const maxScroll = thumbnailList.scrollWidth - thumbnailList.clientWidth;
          const setArrowState = (button, disabled) => {
            button.disabled = disabled;
            const icon = button.querySelector('.kit-pdp__arrow-icon path');
            if (icon) icon.setAttribute('stroke', disabled ? '#8A8A8A' : '#111111');
          };

          setArrowState(previous, thumbnailList.scrollLeft <= 1);
          setArrowState(next, thumbnailList.scrollLeft >= maxScroll - 1);
        };

        previous.addEventListener('click', () => scrollByPage(-1));
        next.addEventListener('click', () => scrollByPage(1));
        thumbnailList.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls, { passive: true });

        controls.append(previous, next);
        thumbnailSlider.append(controls);
        updateControls();
      }
    }
  );
}
